import React, { useCallback } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { FileUploadInfoFragment } from 'src/gqlReactTypings.generated.d';
import styled from 'styled-components';
import { Font } from 'web-common/src/shared/styles';

const DropContainer = styled.div`
  padding: 10px;
  font-family: ${Font.Family.SANS};
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 2px dashed darkgray;
  cursor: pointer;
  * {
    margin: 0;
  }
`;

export type FileEntry =
  | FileUploadInfoFragment
  | {
      error: string;
    };

export const isFileUploadInfo = (x: any): x is FileUploadInfoFragment =>
  x?.hasOwnProperty &&
  Object.prototype.hasOwnProperty.call(x ?? {}, 'signedUrl') &&
  Object.prototype.hasOwnProperty.call(x ?? {}, 'key') &&
  Object.prototype.hasOwnProperty.call(x ?? {}, 'bucket');

type IFileUploadProps = Pick<DropzoneOptions, 'accept' | 'disabled' | 'maxSize' | 'maxFiles'> & {
  className?: string;
  dropzoneComponent?: any;
  onChange: (files: File[]) => void;
};

export const FileUpload: React.FC<React.PropsWithChildren<IFileUploadProps>> = ({
  accept,
  className,
  disabled,
  dropzoneComponent,
  maxSize,
  maxFiles,
  onChange,
  children,
}) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      onChange(acceptedFiles);
    },
    [onChange]
  );
  const { getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone({
    onDrop,
    disabled,
    accept,
    maxSize,
    maxFiles,
  });
  const Dropzone = dropzoneComponent || DropContainer;

  return (
    <Dropzone {...getRootProps({ className, isDragAccept, isDragReject })}>
      <input {...getInputProps()} />
      {children}
    </Dropzone>
  );
};
